import { useRoundsBOStyles } from '../../components/backoffice/businessRound/useRoundsBOStyles';

export default function RedSpan({ children }) {
  const classesCustom = useRoundsBOStyles();
  return <span className={classesCustom.unassigned}>{children}</span>;
}
